import { render } from "./Key4.vue?vue&type=template&id=7cf9330b"
import script from "./Key4.vue?vue&type=script&lang=ts"
export * from "./Key4.vue?vue&type=script&lang=ts"
script.render = render

export default script